import React, { CSSProperties, useEffect, useRef } from 'react';
import { FontWeightType, LabelMedium } from './Text';

interface InputItemType {
  column?:boolean,
  isError?:boolean,
  errorText?:string,
  placeholder?:string,
  style?:CSSProperties,
  type?:string,
  value:string,
  setValue(e:string):void,
  title:string,
  required?:boolean,
  isTextArea?:boolean
}
const InputItem : React.FC<InputItemType> = ({
  column = true,
  isError = false,
  errorText = '',
  placeholder = '',
  style = {},
  value = '',
  setValue,
  title = '',
  type = 'text',
  required = false,
  isTextArea = false,
}) => {
  const textAreaRef = useRef<any>(null);
  const hiddenRef = useRef<any>(null);
  useEffect(() => {
    if (textAreaRef.current !== null) {
      const textarea = textAreaRef.current;
      const hiddenTextarea = hiddenRef.current;
      if (textarea && hiddenTextarea) {
        hiddenTextarea.value = value;
        hiddenTextarea.style.height = 'auto';
        textarea.style.height = `${hiddenTextarea.scrollHeight}px`;
      }
    }
  }, [value]);
  return (
    <div style={{
      display: 'flex', width: '100%', flexDirection: column ? 'column' : 'row', ...style,
    }}
    >
      <div style={{ display: 'flex', marginInlineEnd: 20 }}>
        <LabelMedium style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w700}>{title}</LabelMedium>
        {required ? <div style={{ color: 'red' }}>*</div> : null}
      </div>
      <div style={{ height: 0, overflow: 'hidden' }}>
        <textarea
          ref={hiddenRef}
          value={value}
          rows={1}
          style={{ fontFamily: 'inter' }}
        />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {isTextArea
          ? (
            <textarea
              ref={textAreaRef}
              placeholder={placeholder}
              style={{
                flex: column ? '' : 1,
                backgroundColor: 'transparent',
                borderBottom: '1px solid #979593',
                borderWidth: '0 0 1px',
                fontFamily: 'inter',
                outline: 'none',
                marginTop: column ? 12 : 0,
              }}
              rows={1}
              maxLength={1000}
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          )
          : (
            <input
              placeholder={placeholder}
              type={type}
              style={{
                flex: column ? '' : 1,
                backgroundColor: 'transparent',
                borderBottom: '1px solid #979593',
                borderWidth: '0 0 1px',
                fontFamily: 'inter',
                outline: 'none',
                marginTop: column ? 12 : 0,
              }}
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          )}
        <LabelMedium
          fontWeight={FontWeightType.w600}
          style={{
            fontFamily: 'inter',
            color: isError ? '#DF5C5C' : 'transparent',
          }}
        >
          {errorText}
        </LabelMedium>
      </div>
    </div>
  );
};

export default InputItem;
